import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useParentSessionStore } from "stores/useParentSessionStore";
import { initPromiseContents } from "stores/ParentSessionContentsConst";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

function setScreenSize() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setScreenSize();
window.addEventListener("resize", setScreenSize);

const { getPromiseContents, resetPromiseContents } = useParentSessionStore();
// promiseContents의 key가 icon -> flowPrefix로 변경되며 업데이트 필요
// localStorage에 기존 값이 있는 경우 변경된 값이 적용되지 않아 직접 새 값 적용
// initPromiseContents에 있는 값이 하나라도 없는 경우 값을 덮어 씌움
function checkPromiseContents() {
  const promiseContents = getPromiseContents;
  for (const content in initPromiseContents) {
    if (!promiseContents[content]) {
      resetPromiseContents();
      break;
    }
  }
}
checkPromiseContents();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "NanumSquareOTF" }))
}
}

})